import React, { useState, useEffect, useRef } from 'react';
import './CoachProgramList.css';
import { ORG_NAMES, DAYS_OF_WEEK_DISPLAY } from '../../constants/constants';
import ReactModal from 'react-modal';
import Program from '../Program';
import COACH_RESOURCES from '../../constants/resources';

const formatTime = (time) => {
	const [hour, minute] = time.split(":").map(Number);
	const ampm = hour >= 12 ? 'PM' : 'AM';
	const adjustedHour = hour % 12 || 12;
	return `${adjustedHour}:${minute.toString().padStart(2, '0')} ${ampm}`;
};

const formatSessionDate = (dateStr) => {
	const date = new Date(dateStr + 'T00:00:00');
	return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
};

const CoachProgramListItem = ({ program }) => {
	const {
		roster,
		startDate,
		endDate,
		startTime,
		endTime,
		skippedDates,
		location,
		locationDetails,
		org,
		title,
		daysOfWeek,
		sport,
		type,
		upcomingSessions
	} = program;

	const nextSession = upcomingSessions && upcomingSessions.length > 0 ? upcomingSessions[0] : null;
	const [showModal, setShowModal] = useState(false);
	const [showResources, setShowResources] = useState(false);
	const resourcesRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (resourcesRef.current && !resourcesRef.current.contains(event.target)) {
				setShowResources(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const formatDate = (dateStr) => {
		const date = new Date(dateStr);
		return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
	};

	const getProgramResources = () => {
		const resourceKey = `${sport}_${type}`;
		return COACH_RESOURCES[resourceKey] || [];
	};

	const resources = getProgramResources();

	return (
		<div className="program-item">
			{nextSession && (
				<div className="next-session-banner">
					<span className="next-session-date-large">{formatSessionDate(nextSession.date)} • {formatTime(startTime)} - {formatTime(endTime)}</span>
				</div>
			)}

			<div className="program-header">
				<div className="program-title-section">
					<h3 className="program-title">{title}</h3>
					<span className="program-org">{ORG_NAMES[org]}</span>
				</div>
				<div className="program-stats">
					<span className="roster-count">{roster.length} players</span>
					<button className="view-roster-btn" onClick={() => setShowModal(true)}>
						Attendance
					</button>
					{resources.length > 0 && (
						<div className="resources-dropdown" ref={resourcesRef}>
							<button
								className="resources-btn"
								onClick={() => setShowResources(!showResources)}
							>
								Resources
							</button>
							{showResources && (
								<div className="resources-menu">
									{resources.map((resource, index) => (
										<a
											key={index}
											href={resource.url}
											target="_blank"
											rel="noopener noreferrer"
											className="resource-link"
										>
											{resource.item}
										</a>
									))}
								</div>
							)}
						</div>
					)}
				</div>
			</div>

			<div className="program-details">
				<div className="program-schedule">
					<div className="schedule-icon">📅</div>
					<div className="schedule-info">
						<div className="schedule-dates">
							{formatDate(startDate)} - {formatDate(endDate)}
						</div>
						<div className="schedule-times">
							{DAYS_OF_WEEK_DISPLAY[JSON.stringify(daysOfWeek)]} • {formatTime(startTime)} - {formatTime(endTime)}
						</div>
					</div>
				</div>

				<div className="program-location">
					<div className="location-icon">📍</div>
					<div className="location-info">
						<div className="location-name">{location}</div>
						{locationDetails && <div className="location-details">{locationDetails}</div>}
					</div>
				</div>

				{skippedDates.length > 0 && (
					<div className="skipped-dates">
						<div className="skipped-icon">⚠️</div>
						<div className="skipped-info">
							<span className="skipped-label">Skipped Dates:</span>
							<span className="skipped-dates-list">{skippedDates.join(', ')}</span>
						</div>
					</div>
				)}
			</div>

			<ReactModal
				isOpen={showModal}
				onRequestClose={() => setShowModal(false)}
				shouldCloseOnOverlayClick={true}
				contentLabel="Program Details"
				ariaHideApp={false}
				className="program-modal"
				overlayClassName="program-modal-overlay"
			>
				<Program programId={program?.id} onClose={() => setShowModal(false)} />
			</ReactModal>
		</div>
	);
};

export default CoachProgramListItem;